import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getBrands() {
    return axios.get(ENV.carBaseUrl + "/brands/list", this.requestConfig());
  }

  static deleteBrand(requestData) {
    return axios.post(ENV.carBaseUrl + "/brands/delete", requestData, this.requestConfig());
  }

  static createBrand(requestData) {
    return axios.post(ENV.carBaseUrl + "/brands/create", requestData, this.requestConfig());
  }

  static updateBrand(requestData) {
    return axios.post(ENV.carBaseUrl + "/brands/update", requestData, this.requestConfig());
  }

  static uploadBrandLogo(requestData) {
    return axios.post(ENV.carBaseUrl + "/brands/logo/upload", requestData, this.requestConfig());
  }

  static importBrands(requestData) {
    return axios.post(ENV.carBaseUrl + "/brands/import", requestData, this.requestConfig());
  }

  static exportBrands() {
    return axios.get(ENV.carBaseUrl + "/brands/export", this.requestConfig());
  }
}

export default Service;
